import { Card, Muted, Small, Table, TableBox } from '@widgets/ksp-workspace/parts';
import type { KspRdShift } from '@entities/ksp/types';
import { ru } from '../types';

export interface RdShiftCardProps {
  shift: {
    data?: KspRdShift;
  };
}

export function RdShiftCard({ shift }: RdShiftCardProps) {
  return (
    <Card>
      <h3>Перенос сроков: было / стало</h3>
      {shift.data?.base ? (
        <>
          <Small>
            Сравнение расчёта {new Date(shift.data.target!.created_at).toLocaleString('ru-RU')} с
            предыдущим {new Date(shift.data.base.created_at).toLocaleString('ru-RU')}. Окончание:{' '}
            {ru(shift.data.finish?.was)} → {ru(shift.data.finish?.now)}
            {shift.data.finish?.delta_days != null &&
              ` (${shift.data.finish.delta_days > 0 ? '+' : ''}${shift.data.finish.delta_days} дн.)`}
            . Изменено работ: {shift.data.counts?.changed ?? 0}, из них по РД:{' '}
            {shift.data.counts?.rd ?? 0}.
          </Small>
          <TableBox>
            <Table>
              <thead>
                <tr>
                  <th>Работа</th>
                  <th>Было начало / окончание</th>
                  <th>Стало начало / окончание</th>
                  <th>Причина</th>
                  <th>Влияние</th>
                </tr>
              </thead>
              <tbody>
                {shift.data.rows.map((r) => (
                  <tr key={r.activity_id}>
                    <td>
                      {r.code} {r.name}
                    </td>
                    <td>{r.was ? `${ru(r.was.start)} — ${ru(r.was.finish)}` : 'не рассчитано'}</td>
                    <td>
                      {r.now ? `${ru(r.now.start)} — ${ru(r.now.finish)}` : 'не рассчитано'}
                      {r.shift_days ? (
                        <Small>
                          {r.shift_days > 0 ? '+' : ''}
                          {r.shift_days} дн.
                        </Small>
                      ) : null}
                    </td>
                    <td>{r.reason.text}</td>
                    <td>
                      {r.impact.dependents ? `Зависимых работ: ${r.impact.dependents}. ` : ''}
                      {r.impact.milestones.length ? `Вехи: ${r.impact.milestones.join('; ')}. ` : ''}
                      {r.impact.deadline ?? ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableBox>
          {shift.data.rows.length === 0 && <Muted>Сроки работ не изменились.</Muted>}
        </>
      ) : (
        <Muted>Сравнение появится после второго расчёта версии графика.</Muted>
      )}
    </Card>
  );
}
